module.exports = __webpack_public_path__ + "img/3.a3b32d75.jpg";